import { mailpieceActions } from '@components/MailpieceActions';
import ForceActionsDrawer from '@components/MailpieceActions/ForceActionsDrawer';
import { MailPieceInboxType } from '@rdTypes/shared';

import { closeForceActionsDrawer, resetAction } from '@redux/slices/mailpieceAction';
import { useDispatch, useSelector } from '@redux/store';

export const GlobalMailpieceActionRenderer = () => {
  const dispatch = useDispatch();
  const { currentAction, currentMailpiece, forceActionsDrawer } = useSelector((state) => state.mailpieceAction);

  const handleActionFinish = () => {
    dispatch(resetAction());
  };

  const renderActionComponent = () => {
    if (!currentAction || !currentMailpiece) return null;

    const actionConfig = mailpieceActions[currentAction];
    if (!actionConfig?.Component) return null;

    const { Component } = actionConfig;

    return (
      <Component
        mailpieces={[currentMailpiece]}
        actionStarted={true}
        onActionFinish={handleActionFinish}
        isForce={false}
      />
    );
  };

  return (
    <>
      {renderActionComponent()}

      <ForceActionsDrawer
        open={forceActionsDrawer.open}
        setOpen={(open) => {
          if (!open) {
            dispatch(closeForceActionsDrawer());
          }
        }}
        pieces={forceActionsDrawer.pieces}
        access={MailPieceInboxType.Mailroom}
        pendingSearchValue={forceActionsDrawer.pendingSearchValue}
      />
    </>
  );
};
